import Succeeded from './Succeeded'

export default Succeeded
